import React, { useState } from 'react'
import ModalLovePointsError from 'src/pages/easyrewards/components/ModalLovePointsError/ModalLovePointsError'

const useLovePointsValidator = ({ saldoDisponible, idMembresia }: { saldoDisponible?: number, idMembresia?: string | number }) => {
    const [isModalOpen, setisModalOpen] = useState(false)

    return {
        Modal: isModalOpen && <ModalLovePointsError
            description={`Esta membresía <strong>ID ${idMembresia} </strong> no tiene saldo suficiente para completar la transacción. <br>
                     Te recomendamos intentar nuevamente con otra forma de pago.<br>
                     Actualmente, el huésped cuenta con <strong> ${saldoDisponible} puntos </strong> en su cuenta.`}
            isOpen
            onCloseDialog={() => setisModalOpen(false)}
            setIsOpen={setisModalOpen}

        />,
        setisModalOpen
    }
}

export default useLovePointsValidator